export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-8">
          关于白云视频
        </h2>
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex flex-col md:flex-row items-start gap-8">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-3xl md:text-4xl"></i>
              </div>
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                白云视频 — 您的免费高清影视伙伴
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                白云视频是一个专注于免费高清影视内容的在线平台，提供与西瓜视频同类型的优质观影体验。我们汇聚了海量电影、热播电视剧、热门综艺和人气动漫资源，所有内容均可免费在线观看，无需会员、无需付费。平台采用先进的CDN加速技术，确保播放流畅不卡顿，无论是在电脑还是手机上都能享受高清画质。作为西瓜视频免费替代方案之一，白云视频坚持每日更新片库，让您追剧不等待、看片更尽兴。
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed">
                我们与糖豆视频、小蓝视频等同类平台一起，致力于为广大影迷提供更丰富的免费观影选择。白云视频始终以用户为中心，持续优化播放体验和内容推荐，让每一位用户都能在这里找到心仪的影视作品。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}